import type { DiagnosticCheck } from "../types";

const CHECK_STATUS_ORDER: Record<DiagnosticCheck["status"], number> = {
  fail: 0,
  pass: 2,
  warning: 1,
};

export function sortChecksBySeverity(
  checks: DiagnosticCheck[],
): DiagnosticCheck[] {
  return [...checks].sort(
    (a, b) => CHECK_STATUS_ORDER[a.status] - CHECK_STATUS_ORDER[b.status],
  );
}
